export const CompanyNewsRouting = [
  {
    path: "/information-manage/company-news/list",
    name: "company-news-list",
    meta: { title: "公司新闻" },
    component: () => import("@/views/information-manage/company-news/list/index.vue"),
  },
  {
    hidden: true,
    path: "/information-manage/company-news/create",
    name: "company-news-create",
    meta: { title: "新增公司新闻",comName:"informationManageCompanyNewsFormCreate" },
    component: () => import("@/views/information-manage/company-news/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/information-manage/company-news/edit/:id",
    name: "company-news-edit",
    meta: { title: "编辑公司新闻",comName:"informationManageCompanyNewsFormCreate" },
    component: () => import("@/views/information-manage/company-news/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/information-manage/company-news/detail/:id",
    name: "company-news-detail",
    meta: { title: "公司新闻详情" },
    component: () => import("@/views/information-manage/company-news/form-detail/index.vue"),
  },
];
